import styles from './Rocket.module.scss';
import image from '../../images/rocket.svg';
import React from 'react';

function Rocket() {
  return <img src={image} className={styles.image} alt="Rocket Image" />;
}

export default Rocket;
